routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.payZoneDashboard', {
      url: "zona-de-pagos/dashboard",
      template: `<pay-zone-dashboard sh-ctrl="shCtrl"></pay-zone-dashboard>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/dashboard/dashboard.config.js
 **/